import * as t from 'io-ts';
import { NonEmptyString } from 'io-ts-types';

export const VehicleIdCodec = t.partial({
    vin: NonEmptyString,
    production_number: NonEmptyString,
});

export enum ApiCategory {
    CAMPER_VAN = 'camper-van',
    CAR = 'car',
    MOTORCYCLE = 'motorcycle',
    QUAD = 'quad',
    SPECIAL_VEHICLE = 'special-vehicle',
    TRIKE = 'trike',
    TRUCK = 'truck',
    VAN = 'van',
}

export enum ApiFuelType {
    DIESEL = 'diesel',
    DIESEL_ELECTRIC = 'diesel-electric',
    ELECTRIC = 'electric',
    LIQUID_PROPANE_GAS = 'liquid-propane-gas',
    PETROL = 'petrol',
    PETROL_ELECTRIC = 'petrol-electric',
    HYDROGEN = 'hydrogen',
    COMPRESSED_NATURAL_GAS = 'compressed-natural-gas',
    LIQUID_NATURAL_GAS = 'liquid-natural-gas',
}

export const VehicleDimensionsCodec = t.partial({
    length: t.number,
    width: t.number,
    height: t.number,
});

export enum ApiVehicleType {
    NEW = 'new',
    USED = 'used',
    OTHER = 'other',
}

export const CustomsInformationCodec = t.intersection([
    t.type({
        customs_reference_number: NonEmptyString,
    }),
    t.partial({
        customs_reference_number_issued_at: NonEmptyString,
    }),
]);

export type ApiCustomsInformation = t.TypeOf<typeof CustomsInformationCodec>;
export type ApiVehicleId = t.TypeOf<typeof VehicleIdCodec>;
export type ApiVehicleDimensions = t.TypeOf<typeof VehicleDimensionsCodec>;
